// import { ArrowRight, Check, Edit3, Star } from 'lucide-react';
// import { FC, useEffect, useState } from 'react';

// const Hero: FC = () => {
//   const [showScoreAnimation, setShowScoreAnimation] = useState<boolean>(false);

//   useEffect(() => {
//     const timer = setTimeout(() => setShowScoreAnimation(true), 2500);
//     return () => clearTimeout(timer);
//   }, []);

//   return (
//     <section className='py-16 md:py-24 container mx-auto px-4 overflow-hidden relative bg-transparent'>
//       <div className='grid lg:grid-cols-2 gap-12 items-center relative z-10'>
//         <div className='space-y-6 max-w-xl'>
//           <div className='inline-flex items-center space-x-2 bg-primary/10 text-primary px-4 py-2 rounded-md text-sm font-medium animate-fadeIn'>
//             <Star size={16} className='text-primary' />
//             <span>Trusted by 10,000+ job seekers</span>
//           </div>
//           <h1 className='text-4xl lg:text-5xl xl:text-6xl font-bold leading-tight transition-smooth text-foreground'>
//             Land Your{' '}
//             <span className='relative animate-gradient bg-gradient-to-r from-primary via-chart-1 to-chart-4 text-transparent bg-clip-text'>
//               Dream Job
//               <span className='absolute -bottom-2 left-0 w-full h-1 bg-primary/30 rounded-full'></span>
//             </span>{' '}
//             with an ATS-Ready Resume
//           </h1>
//           <p className='text-xl text-muted-foreground'>
//             Create a professional, ATS-optimized resume in{' '}
//             <span className='font-bold'>under 10 minutes</span>.
//           </p>
//           <div className='flex flex-col sm:flex-row gap-4 pt-4'>
//             <button className='flex-1 bg-primary text-primary-foreground rounded-md px-6 py-4 text-lg font-medium transition-smooth hover:bg-primary/90 hover:shadow-lg group'>
//               <span className='flex items-center justify-center'>
//                 Start Free Trial
//                 <ArrowRight
//                   size={18}
//                   className='ml-2 transition-transform duration-300 group-hover:translate-x-1'
//                 />
//               </span>
//             </button>
//             <button className='flex-1 border border-border bg-transparent text-foreground rounded-md px-6 py-4 text-lg font-medium transition-smooth hover:bg-secondary/10'>
//               View Pricing
//             </button>
//           </div>
//         </div>
//         <div className='relative'>
//           <div className='absolute top-0 right-0 w-64 h-64 bg-primary/10 rounded-full filter blur-3xl -z-10 opacity-50 animate-subtlePulse'></div>
//           <div className='bg-card rounded-xl shadow-lg overflow-hidden border border-border p-6 transition-smooth hover:shadow-xl hover:border-primary/20'>
//             <div className='flex justify-between items-center mb-6'>
//               <h3 className='font-bold text-xl text-card-foreground'>John Anderson</h3>
//               <div
//                 className={`transition-smooth flex items-center space-x-2 ${
//                   showScoreAnimation
//                     ? 'bg-chart-2/10 text-chart-2'
//                     : 'bg-primary/10 text-primary'
//                 } px-3 py-1 rounded-full text-sm font-medium`}>
//                 <span>Score: {showScoreAnimation ? '93' : '75'}/100</span>
//                 {showScoreAnimation && <Check size={14} className='animate-fadeIn' />}
//               </div>
//             </div>
//             <div className='space-y-4'>
//               <div>
//                 <h4 className='font-medium text-sm text-muted-foreground'>
//                   PROFESSIONAL SUMMARY
//                 </h4>
//                 <p className='mt-1 border border-border rounded-md p-3 bg-secondary/5 text-sm text-card-foreground'>
//                   Senior Marketing Manager with{' '}
//                   <span
//                     className={`${
//                       showScoreAnimation ? 'bg-chart-2/10 text-chart-2' : ''
//                     } transition-smooth rounded px-1`}>
//                     7+ years of experience
//                   </span>{' '}
//                   driving growth.
//                 </p>
//               </div>
//               <div>
//                 <h4 className='font-medium text-sm text-muted-foreground'>EXPERIENCE</h4>
//                 <div className='mt-1 border border-border rounded-md p-3 bg-secondary/5 text-sm text-card-foreground'>
//                   <p className='font-medium'>Marketing Director • TechCorp</p>
//                   <ul className='mt-2 space-y-2 pl-5 list-disc'>
//                     <li>Led team to achieve 210% YoY growth</li>
//                     <li
//                       className={`transition-smooth rounded p-1 ${
//                         showScoreAnimation ? 'bg-chart-2/10' : 'bg-primary/5'
//                       }`}>
//                       {showScoreAnimation
//                         ? 'Increased revenue by $1.2M'
//                         : 'Managed marketing budget'}
//                     </li>
//                   </ul>
//                 </div>
//               </div>
//             </div>
//             <div className='absolute -bottom-3 -right-3 bg-primary text-primary-foreground p-3 rounded-md shadow-md transition-smooth hover:bg-primary/90'>
//               <Edit3 size={20} />
//             </div>
//           </div>
//         </div>
//       </div>
//     </section>
//   );
// };

// export default Hero;

import { ArrowRight, Check, RefreshCw, Star } from 'lucide-react';
import { FC, useEffect, useState } from 'react';

const Hero: FC = () => {
  const [showScoreAnimation, setShowScoreAnimation] = useState<boolean>(false);
  const [isHovering, setIsHovering] = useState<{
    primary: boolean;
    secondary: boolean;
    edit: boolean;
    toggle: boolean;
  }>({
    primary: false,
    secondary: false,
    edit: false,
    toggle: false,
  });

  useEffect(() => {
    const timer = setTimeout(() => setShowScoreAnimation(true), 2500);
    return () => clearTimeout(timer);
  }, []);

  const toggleOptimization = () => {
    setShowScoreAnimation(!showScoreAnimation);
  };

  return (
    <section className='py-16 md:py-24 container mx-auto px-4 overflow-hidden relative bg-transparent'>
      <div className='grid lg:grid-cols-2 gap-12 items-center relative z-10'>
        <div className='space-y-6 max-w-xl'>
          <div className='inline-flex items-center space-x-2 bg-primary/10 text-primary px-4 py-2 rounded-md text-sm font-medium animate-fadeIn'>
            <Star size={16} className='text-primary animate-pulse' />
            <span>Trusted by 10,000+ job seekers</span>
          </div>
          <h1 className='text-4xl lg:text-5xl xl:text-6xl font-bold leading-tight transition-smooth text-foreground'>
            Land Your{' '}
            <span className='relative animate-gradient bg-gradient-to-r from-primary via-red-400 to-primary bg-clip-text text-transparent'>
              Dream Job
              <span className='absolute -bottom-2 left-0 w-full h-1 bg-primary/30 rounded-full'></span>
            </span>{' '}
            with an ATS-Ready Resume
          </h1>
          <p className='text-xl text-muted-foreground'>
            Create a professional, ATS-optimized resume in{' '}
            <span className='font-bold'>under 10 minutes</span>.
          </p>
          <div className='flex flex-col sm:flex-row gap-4 pt-4'>
            <button
              className={`flex-1 bg-primary text-primary-foreground rounded-md px-6 py-4 text-lg font-medium 
                transition-all duration-300 
                ${
                  isHovering.primary
                    ? 'shadow-lg shadow-primary/20 translate-y-[-2px]'
                    : 'shadow-md'
                } 
                cursor-pointer`}
              onMouseEnter={() => setIsHovering((prev) => ({ ...prev, primary: true }))}
              onMouseLeave={() => setIsHovering((prev) => ({ ...prev, primary: false }))}>
              <span className='flex items-center justify-center'>
                Start Free Trial
                <ArrowRight
                  size={18}
                  className={`ml-2 transition-transform duration-300 ${
                    isHovering.primary ? 'translate-x-1' : ''
                  }`}
                />
              </span>
            </button>
            <button
              className={`flex-1 border border-border bg-transparent text-foreground rounded-md px-6 py-4 text-lg font-medium 
                transition-all duration-300 
                ${
                  isHovering.secondary
                    ? 'bg-secondary/10 border-primary/30 translate-y-[-2px]'
                    : ''
                } 
                cursor-pointer`}
              onMouseEnter={() => setIsHovering((prev) => ({ ...prev, secondary: true }))}
              onMouseLeave={() =>
                setIsHovering((prev) => ({ ...prev, secondary: false }))
              }>
              View Pricing
            </button>
          </div>

          {/* Added testimonial for social proof */}
          <div className='mt-6 flex items-center space-x-3 opacity-80 hover:opacity-100 transition-opacity'>
            <div className='flex -space-x-2'>
              {[1, 2, 3].map((i) => (
                <div
                  key={i}
                  className='w-8 h-8 rounded-full bg-primary/20 border-2 border-card flex items-center justify-center text-xs font-bold text-primary'>
                  {['JD', 'AL', 'MK'][i - 1]}
                </div>
              ))}
            </div>
            <p className='text-sm text-muted-foreground italic'>
              "Helped me land interviews at{' '}
              <span className='font-medium text-foreground'>3 top companies</span> in just
              2 weeks!"
            </p>
          </div>
        </div>

        <div className='relative'>
          <div className='absolute top-0 right-0 w-64 h-64 bg-primary/10 rounded-full filter blur-3xl -z-10 opacity-50 animate-subtlePulse'></div>
          <div className='bg-card py-12 rounded-xl shadow-lg overflow-hidden border border-border p-6 transition-all duration-300 hover:shadow-xl hover:border-primary/20 relative'>
            {/* Toggle button */}
            <button
              onClick={toggleOptimization}
              className={`absolute bottom-2 right-6 bg-card text-foreground px-3 py-1.5 rounded-md border border-border
                transition-all duration-300 text-xs font-medium flex items-center space-x-1.5 cursor-pointer
                ${isHovering.toggle ? 'shadow-md border-primary/30' : ''}
                ${showScoreAnimation ? 'text-chart-2' : ''}`}
              onMouseEnter={() => setIsHovering((prev) => ({ ...prev, toggle: true }))}
              onMouseLeave={() => setIsHovering((prev) => ({ ...prev, toggle: false }))}>
              <RefreshCw
                size={12}
                className={`transition-transform duration-300 ${
                  isHovering.toggle ? 'rotate-180' : ''
                }`}
              />
              <span>{showScoreAnimation ? 'Show Unoptimized' : 'Show Optimized'}</span>
            </button>

            <div className='flex justify-between items-center mb-6'>
              <h3 className='font-bold text-xl text-card-foreground'>John Anderson</h3>
              <div
                className={`transition-all duration-300 flex items-center space-x-2 ${
                  showScoreAnimation
                    ? 'bg-chart-2/15 text-chart-2 scale-105'
                    : 'bg-primary/10 text-primary'
                } px-3 py-1 rounded-full text-sm font-medium`}>
                <span>Score: {showScoreAnimation ? '85' : '62'}/100</span>
                {showScoreAnimation && (
                  <Check size={14} className='animate-fadeIn ml-1' />
                )}
              </div>
            </div>
            <div className='space-y-5'>
              <div>
                <h4 className='font-medium text-sm text-muted-foreground uppercase tracking-wider mb-2'>
                  Professional Summary
                </h4>
                <p className='border border-border rounded-md p-3 bg-secondary/5 text-sm text-card-foreground'>
                  {showScoreAnimation ? (
                    <>
                      Senior Marketing Manager with{' '}
                      <span className='bg-chart-2/15 text-chart-2 font-medium transition-all duration-300 rounded px-1'>
                        7+ years of experience
                      </span>{' '}
                      driving growth.
                    </>
                  ) : (
                    'Marketing manager with experience driving growth.'
                  )}
                </p>
              </div>
              <div>
                <h4 className='font-medium text-sm text-muted-foreground uppercase tracking-wider mb-2'>
                  Experience
                </h4>
                <div className='border border-border rounded-md p-3 bg-secondary/5 text-sm text-card-foreground'>
                  <p className='font-medium mb-2'>
                    {showScoreAnimation ? 'Marketing Director' : 'Marketing Manager'} •
                    TechCorp
                  </p>
                  <ul className='space-y-2 pl-5 list-disc'>
                    <li>
                      {showScoreAnimation
                        ? 'Led team to achieve 210% YoY growth'
                        : 'Led marketing team'}
                    </li>
                    <li
                      className={`transition-all duration-500 rounded p-1 ${
                        showScoreAnimation
                          ? 'bg-chart-2/15 transform scale-[1.02]'
                          : 'bg-primary/5'
                      }`}>
                      {showScoreAnimation
                        ? 'Increased revenue by $1.2M'
                        : 'Managed marketing budget'}
                    </li>
                    <li>
                      {showScoreAnimation
                        ? 'Implemented data-driven approach resulting in 37% increase in conversion rates'
                        : 'Created campaigns'}
                    </li>
                  </ul>
                </div>
              </div>

              {/* Additional skills section that only appears when optimized */}
              {showScoreAnimation && (
                <div className='animate-fadeIn'>
                  <h4 className='font-medium text-sm text-muted-foreground uppercase tracking-wider mb-2'>
                    Skills
                  </h4>
                  <div className='border border-chart-2/30 rounded-md p-3 bg-chart-2/5'>
                    <div className='flex flex-wrap gap-2'>
                      {[
                        'Digital Marketing',
                        'Team Leadership',
                        'SEO/SEM',
                        'Analytics',
                        'Content Strategy',
                      ].map((skill) => (
                        <span
                          key={skill}
                          className='bg-primary/10 text-primary px-2 py-1 rounded text-xs font-medium'>
                          {skill}
                        </span>
                      ))}
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
